<template>
    <div v-if="answers.length" class="summary">
        <h3 class="summary-title">{{ t('title') }}</h3>
        <ul class="no-bullet summary-list">
            <li v-for="(a, i) in summaryData" :key="i" class="summary-item">
                <strong>{{ a.label }} :</strong>
                <div v-html="a.value"></div>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
    answers: {
        type: Array,
        default: () => [],
    },
    summaryFromResult: {
        type: Array,
        default: () => [],
    },
});

const { t } = useI18n({
    messages: {
        fr: {
            title: 'Résumé de votre demande',
        },
        en: {
            title: 'Summary of your search',
        },
    },
});

const summaryFromResultFormatted = computed(() => {
    if (!props.summaryFromResult || !props.summaryFromResult.length) {
        return null;
    }

    return props.summaryFromResult.map((string) => {
        const match = string.match(/^(.*?)\s*:\s*(.*)$/);
        return match ? { label: match[1].trim(), value: match[2].trim() } : { label: string.trim(), value: '' };
    });
});

const summaryData = computed(() => {
    return summaryFromResultFormatted.value ?? props.answers;
});
</script>

<style lang="scss" scoped>
.summary {
    margin-bottom: 16px;
}
.summary-title {
    @include rem-typo(18px);
    font-weight: 800;
    @include breakpoint(medium) {
        @include rem-typo(20px);
    }
}
.summary-item {
    display: flex;
    flex-direction: column;
    gap: 8px 16px;
    margin-bottom: 8px;
    background-color: $color-black-2;
    padding: 16px;
    border-radius: 15px;
    @include breakpoint(medium) {
        align-items: flex-start;
        flex-direction: row;
        padding: 24px;
    }
    &:last-child {
        margin-bottom: 0;
    }
    strong {
        display: block;
        @include breakpoint(medium) {
            width: 25%;
        }
    }
}
</style>
